import "@obsina/design-system/fonts";
import "@obsina/design-system/styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthenticatedRoot } from "./auth";
import { enMessages } from "./messages";
import {
  readOAuthOutcomeFromLocation,
  resolveOAuthPopupLanding,
} from "./oauth-popup";
import "./styles.css";

const root = document.getElementById("root");

if (!root) throw new Error("Obsina could not find the application root.");

const reactRoot = createRoot(root);

function renderApplication(): void {
  reactRoot.render(
    <StrictMode>
      <AuthenticatedRoot />
    </StrictMode>,
  );
}

function renderPopupNotice(message: string): void {
  reactRoot.render(
    <StrictMode>
      <p className="oauth-popup-closing" role="status">
        {message}
      </p>
    </StrictMode>,
  );
}

if (readOAuthOutcomeFromLocation(window.location.search) === null) {
  renderApplication();
} else {
  // An OAuth callback landing. This may be the authorization popup (which must
  // signal its opener and close) or a main tab that finished OAuth via a
  // full-page redirect (which renders the app). A COOP swap can sever the
  // popup's opener, so the two are told apart by a same-origin broadcast
  // handshake; show a neutral notice while it resolves.
  renderPopupNotice(enMessages.oauthPopupCompleting);
  void resolveOAuthPopupLanding(window).then((role) => {
    if (role === "application") {
      renderApplication();
    } else {
      renderPopupNotice(enMessages.oauthPopupClosing);
    }
  });
}
